// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@use "styles/mixins" as *;
@use "styles/colors" as *;
@use "styles/dimensions" as *;

.styles-module__root___YCWyP {
  @include flex(column);
  padding: 24px;
  position: relative;

  .styles-module__add-button___R8iZo {
    width: 183px;
  }

  .styles-module__header____J_6O {
    @include flex(row, space-between, center);
    margin-bottom: 16px;
    position: relative;

    h3 {
      @include font(24px, \$font-weight-medium, \$s900, 32px);
      margin: 0;
    }
  }

  .styles-module__scrollBar___H25hn {
    &-track {
      z-index: 2;
    }
  }

  .styles-module__content____uk4W {
    @include flex;
    @include size(100%, 100%);
    margin-bottom: 16px;
    position: relative;
  }

  .styles-module__rowDialogTarget___N4PQF {
    top: calc(100% - 10px);
    left: 25px;
  }

  .styles-module__columnDialogTarget___PomXn {
    left: 100% !important;
  }
}

.styles-module__copied-to-clipboard-message___XdngT {
  position: absolute;
  left: 1px;
  top: 80px;
  width: calc(100% - 3px);
  z-index: 2;
}

.styles-module__threeDotsMenu___bm5LY {
  display: none;
  position: absolute;
  right: 4px;
  top: calc(50% - 12px);

  &:hover {
    background: \$ab10;
  }

  &:active {
    background: \$ab20;
  }
}

.styles-module__linkBlock___HSgRB {
  padding-top: 16px;
}

@include infoTooltip;

 {
  .styles-module__scrollBar___H25hn {
    &.styles-module__scrollBar-isHorizontalTrackVisible___pcnM0 {
      .styles-module__table___dt3EP {
        tbody {
          tr {
            &:last-child {
              .styles-module__row-item___IhBiN {
                padding-bottom: 10px;
              }
            }
          }
        }
      }
    }
  }
}

@media print {
  .styles-module__root___YCWyP {
    display: block;
    page-break-inside: unset !important;
    page-break-after: always;

    > * {
      page-break-inside: avoid;
      margin-bottom: 24px;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/RS-Workspace/components/Results/components/Elements/components/TableElement/styles.module.scss"],"names":[],"mappings":"AAAA,yBAAyB;AACzB,yBAAyB;AACzB,6BAA6B;;AAE7B;EACE,qBAAqB;EACrB,aAAa;EACb,kBAAkB;;EAElB;IACE,YAAY;EACd;;EAEA;IACE,yCAAyC;IACzC,mBAAmB;IACnB,kBAAkB;;IAElB;MACE,qDAAqD;MACrD,SAAS;IACX;EACF;;EAEA;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,qBAAqB;;EAErB;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA,oBAAoB;;AAEpB;EACE;IACE;MACE;QACE;UACE;YACE;cACE;gBACE,oBAAoB;cACtB;YACF;UACF;QACF;MACF;IACF;EACF;AACF;;AAEA;EACE;IACE,cAAc;IACd,mCAAmC;IACnC,wBAAwB;;IAExB;MACE,wBAAwB;MACxB,mBAAmB;IACrB;EACF;AACF","sourcesContent":["@use \"styles/mixins\" as *;\r\n@use \"styles/colors\" as *;\r\n@use \"styles/dimensions\" as *;\r\n\r\n.root {\r\n  @include flex(column);\r\n  padding: 24px;\r\n  position: relative;\r\n\r\n  .add-button {\r\n    width: 183px;\r\n  }\r\n\r\n  .header {\r\n    @include flex(row, space-between, center);\r\n    margin-bottom: 16px;\r\n    position: relative;\r\n\r\n    h3 {\r\n      @include font(24px, $font-weight-medium, $s900, 32px);\r\n      margin: 0;\r\n    }\r\n  }\r\n\r\n  .scrollBar {\r\n    &-track {\r\n      z-index: 2;\r\n    }\r\n  }\r\n\r\n  .content {\r\n    @include flex;\r\n    @include size(100%, 100%);\r\n    margin-bottom: 16px;\r\n    position: relative;\r\n  }\r\n\r\n  .rowDialogTarget {\r\n    top: calc(100% - 10px);\r\n    left: 25px;\r\n  }\r\n\r\n  .columnDialogTarget {\r\n    left: 100% !important;\r\n  }\r\n}\r\n\r\n.copied-to-clipboard-message {\r\n  position: absolute;\r\n  left: 1px;\r\n  top: 80px;\r\n  width: calc(100% - 3px);\r\n  z-index: 2;\r\n}\r\n\r\n.threeDotsMenu {\r\n  display: none;\r\n  position: absolute;\r\n  right: 4px;\r\n  top: calc(50% - 12px);\r\n\r\n  &:hover {\r\n    background: $ab10;\r\n  }\r\n\r\n  &:active {\r\n    background: $ab20;\r\n  }\r\n}\r\n\r\n.linkBlock {\r\n  padding-top: 16px;\r\n}\r\n\r\n@include infoTooltip;\r\n\r\n:global {\r\n  :local(.scrollBar) {\r\n    &.scrollBar-isHorizontalTrackVisible {\r\n      :local(.table) {\r\n        tbody {\r\n          tr {\r\n            &:last-child {\r\n              :local(.row-item) {\r\n                padding-bottom: 10px;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media print {\r\n  .root {\r\n    display: block;\r\n    page-break-inside: unset !important;\r\n    page-break-after: always;\r\n\r\n    > * {\r\n      page-break-inside: avoid;\r\n      margin-bottom: 24px;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var root = `styles-module__root___YCWyP`;
var _1 = `styles-module__add-button___R8iZo`;
export { _1 as "add-button" };
export var header = `styles-module__header____J_6O`;
export var scrollBar = `styles-module__scrollBar___H25hn`;
export var content = `styles-module__content____uk4W`;
export var rowDialogTarget = `styles-module__rowDialogTarget___N4PQF`;
export var columnDialogTarget = `styles-module__columnDialogTarget___PomXn`;
var _2 = `styles-module__copied-to-clipboard-message___XdngT`;
export { _2 as "copied-to-clipboard-message" };
export var threeDotsMenu = `styles-module__threeDotsMenu___bm5LY`;
export var linkBlock = `styles-module__linkBlock___HSgRB`;
var _3 = `styles-module__scrollBar-isHorizontalTrackVisible___pcnM0`;
export { _3 as "scrollBar-isHorizontalTrackVisible" };
export var table = `styles-module__table___dt3EP`;
var _4 = `styles-module__row-item___IhBiN`;
export { _4 as "row-item" };
export default ___CSS_LOADER_EXPORT___;
